import * as React from 'react'
import {Hub} from 'yougile-model'
import {Link} from '@components/sticker/my-stickers/common/add-link/add-link'
import {ChatUtils} from '@extensions/chat-utils'

export const PathToCol = ({hub}: {hub?: Hub}) => {
  if (!hub) {
    return null
  }

  const titles = ChatUtils.getSplitChatLocation(hub, 'column')

  return (
    <div className="flex leading-4 gap-4">
      <Link>{titles[0]}</Link>
      <div>»</div>
      <Link>{titles[1]}</Link>
      <div>»</div>
      <Link>{titles[2]}</Link>
    </div>
  )
}
